<template>
  <div>
    <div style="display: flex; width: 100%">
      <input class="form-control mb-0" type="file" id="new-attachment-input" multiple />
      <el-button type="secondary" @click="onClickAddNewAttachments($event)">Upload</el-button>
    </div>
    <div v-if="ExceptionRequestDocs">
      <a :href="baseURL + item" target="_blank" class="uploadItem" :key="i" v-for="(item, i) in ExceptionRequestDocs">{{ baseURL + item }}</a>
    </div>
  </div>
</template>

<script>
import DataSource from '../../data/datasource'

export default {
  name: 'K2Upload',
  props: ['ExceptionRequestDocs'],
  data() {
    return {
      baseURL: '',
    }
  },
  mounted() {
    this.baseURL = `${process.env.VUE_APP_ROOT_API}`
  },
  methods: {
    async onClickAddNewAttachments() {
      const inputFiles = document.querySelector('#new-attachment-input')?.files
      const files = []
      for await (let file of inputFiles) {
        if (file.size / 1024 / 1024 > 10) {
          this.$notify.error({ title: 'Error', message: 'File limit exceeded 10MB' })
          continue
        }
        files.push(file)
      }
      if (files.length > 0) {
        const response = await DataSource.shared.uploadFiles(files)
        if (response) {
          this.$emit('setExceptionRequestDocs', response)
        }
      } else {
        this.$notify.error({ title: 'Error', message: 'No Files Selected' })
      }
    },
  },
}
</script>

<style>
.uploadItem {
  display: block;
  background: #ecf5ff;
  border: 1px solid #c6e2ff;
  margin: 10px 0;
  padding: 6px;
  word-break: break-all;
  color: #409eff;
  font-size: 11px;
  font-weight: normal;
}
</style>
